import React from 'react';
import { Container, makeStyles } from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import TermDatatable from 'src/term/ui/components/TermDatatable';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const TermListView = () => {
  const classes = useStyles();

  const handleEdit = () => {};

  return (
    <Page className={classes.root} title="Cuotas pendientes">
      <Container maxWidth={false}>
        <TermDatatable showAddButton={false} />
      </Container>
    </Page>
  );
};

export default TermListView;
